import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';
import { IAppState } from '../classes/app';
import { IOption } from '../classes/input-option';

export enum Sort {
    Random,
    AtoZ,
    ZtoA,
    Date
}


interface IExternalProps {
    property: string;
    title: string;
    description?: string;
    defaultOption?: IOption;
    options?: IOption[];
}

interface StateToProps {
    options?: IOption[];
    selectedOptions?: string
}

export class SortOptionsDate extends FilterBase {

    convertEvtToString(evt: React.MouseEvent<HTMLButtonElement>) {
        return evt.currentTarget.value
    }

    submitChange(evt: React.MouseEvent<HTMLButtonElement>) {

        // this.updateValue(evt)
        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    render() {
        return (
            <div className="adage-search-results-header-sort-item">
                <span className="adage-search-results-header-label">Sort {this.props.description} By:</span>
                {

                    this.props.options.map((option, index) => {
                        if (option.value == this.props.selectedOptions || (!this.props.selectedOptions && option.text == "Date")) {

                            return <span className="sort-trigger" key={index + option.text}>{option.text}</span>
                        }
                        else {
                            return <button className="btn-text sort-trigger" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>
                        }
                    })


                }
            </div>
        )
    }
}

export function sortMapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const options = state.filtersState.filterOptions[ownProps.property];

    return {
        options: options ? options.map(option => { return { text: parseInt(option) == Sort.AtoZ ? "A - Z" : "Date", value: option.toString() } }) : [],
        selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : ""
    }
}


export const ConnectedSortDate = connect(sortMapStateToProps, mapDispatchToProps)(SortOptionsDate);